import { jsxs as u, Fragment as y, jsx as r } from "react/jsx-runtime";
import { useMemo as f, createElement as C } from "react";
import { useField as E } from "formik";
import { HintLabel as j } from "../Input/styled.js";
import { Option as k, OptionPlaceholder as D, Container as S, Label as q, SelectWrapper as H, Select as M, ErrorLabel as T } from "./styled.js";
const G = ($) => {
  const {
    name: e,
    label: c = "",
    ariaLabel: g = "",
    placeholder: t = "Please Choose...",
    disabled: h = !1,
    required: L = !1,
    options: l,
    allowLong: m = !1,
    labelProps: F,
    errorProps: o,
    containerProps: O,
    selectProps: P,
    hint: b
  } = $, [s, a] = E(e), d = a.touched && a.error, v = 35, p = f(() => m && l.some((n) => n.label.length > v), [m, l]), w = f(() => {
    const n = l.map((i, x) => /* @__PURE__ */ C(k, { ...i, key: i.key || `${i.label}_${x}` }, i.label));
    return s.value ? n : /* @__PURE__ */ u(y, { children: [
      /* @__PURE__ */ r(D, { hidden: !0, children: t }),
      n
    ] });
  }, [l, t, s.value]);
  return /* @__PURE__ */ u(S, { $long: p, ...O, children: [
    /* @__PURE__ */ r(q, { htmlFor: e, id: `${e}.label`, ...F, children: c }),
    /* @__PURE__ */ r(H, { children: /* @__PURE__ */ r(
      M,
      {
        ...s,
        "aria-label": g || c,
        placeholder: t,
        required: L,
        disabled: h,
        "aria-disabled": h,
        $touched: a.touched,
        $long: p,
        "aria-invalid": !!d,
        "aria-labelledby": `${e}.label`,
        ...d ? { "aria-errormessage": (o == null ? void 0 : o.id) ?? `${e}.errorlabel` } : {},
        ...P,
        children: w
      }
    ) }),
    d && /* @__PURE__ */ r(T, { htmlFor: e, id: `${e}.errorlabel`, ...o, children: a.error }),
    b && /* @__PURE__ */ r(j, { children: b })
  ] });
};
export {
  G as Dropdown,
  G as default
};
